import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object } from "yup";
import { MoveToArchiveFormValues } from "src/models/Inquiry.model";
import MoveToArchiveForm from "./MoveToArchiveForm";
import { useMoveToArchiveMutation } from "src/services/InquiryServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
  inquiryId: string;
};

const MoveToArchiveFormWrapper = ({ onClose, inquiryId }: Props) => {
  const [moveToArchive] = useMoveToArchiveMutation();

  // Form Initial Values
  const initialValues: MoveToArchiveFormValues = {
    reason: "",
    description: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    reason: object().required("Please enter reason"),
  });

  // Handle Submit
  const handleSubmit = (
    values: MoveToArchiveFormValues,
    { setSubmitting, resetForm }: FormikHelpers<MoveToArchiveFormValues>
  ) => {
    const formattedValues = {
      archiveReason: values?.reason?.value,
      archivedescription: values?.description,
    };
    moveToArchive({
      id: inquiryId,
      body: formattedValues,
    }).then((res: any) => {
      setSubmitting(false);
      if (res.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose()
        } else {
          showToast("error", res?.data?.message);
        }
      }
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <MoveToArchiveForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default MoveToArchiveFormWrapper;
